<template>
  <div>
    <a-modal :title="title" :visible.sync="visible" :confirm-loading="saving" @cancel="clear" @ok="submit" width="500px">
      <a-divider orientation="left" style="margin: 0 0 8px 0"><span class="font-sm">操作权限</span></a-divider>
      <a-tree @check="onCheck" :tree-data="menuOptions" v-model="checkedKeys" checkable ref="menu" node-key="id" :replace-fields="{ children: 'children', key: 'id', value: 'id', title: 'name' }"></a-tree>
      <!-- <a-divider></a-divider> -->
      <a-divider orientation="left" style="margin: 8px 0"><span class="font-sm">项目权限</span></a-divider>
      <div class="v-pl-sm">
        <a-checkbox-group v-model="checkedTypes" @change="onCheckChange">
          <div class="flex">
            合作项目
            <div class="col v-ml-md">
              <a-row :gutter="[4, 2]">
                <a-col :span="8">
                  <a-checkbox :value="11">公募合作</a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox :value="12">专项基金</a-checkbox>
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="flex v-mt-sm">
            自有项目
            <div class="col v-ml-md">
              <a-row :gutter="[4, 2]">
                <a-col :span="8">
                  <a-checkbox :value="21">螺蛳壳改造</a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox :value="22">精灵书屋</a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox :value="23">公益人才</a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox :value="24">爱心100</a-checkbox>
                </a-col>
                <a-col :span="8">
                  <a-checkbox :value="25">其他项目</a-checkbox>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-checkbox-group>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getAllMenus } from '@/api/system/menu'
import { saveRoleMenu, getMenuIdsByRole, getRoleProjectTypes } from '@/api/system/role'
export default {
  name: 'menu-permission',
  data() {
    return {
      visible: false,
      roleId: undefined,
      roleName: undefined,
      title: undefined,
      form: {},
      checkedTypes: [],
      checkAll: false,
      // 菜单列表
      menuOptions: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      // 记录所有父节点ID，在tree半选中时使用。注意：选中父节点会把下面所有子节点全部选中
      parentNodeIds: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      projectTypes: [
        { label: '公募合作(合作项目）', value: 11 },
        { label: '专项基金', value: 12 },
        { label: '螺蛳壳改造', value: 21 },
        { label: '精灵书屋', value: 22 },
        { label: '公益人才', value: 23 },
        { label: '爱心100', value: 24 },
      ],
      saving: false,
    }
  },
  methods: {
    onCheck(checkedKeys, info) {
      this.halfCheckedKeys = info.halfCheckedKeys
    },
    open(roleId, roleName) {
      this.roleId = roleId
      this.roleName = roleName
      this.title = '权限配置：' + roleName + ''
      this.visible = true
      this.checkedTypes = []
      getMenuIdsByRole(roleId).then(response => {
        let data = response.data.result
        this.checkedKeys = []
        for (let menuId of data) {
          if (this.parentNodeIds.indexOf(menuId) == -1) {
            this.checkedKeys.push(menuId)
          }
        }
      })
      getRoleProjectTypes(roleId).then(({ data }) => {
        if (data.success) {
          this.checkedTypes = data.result
        }
      })
    },
    /** 查询菜单树结构 */
    getMenuTreeselect() {
      getAllMenus().then(response => {
        let data = response.data.result
        this.menuOptions = data
        this.takeParentNodeIds(Object.values(data))
      })
    },
    takeParentNodeIds(treeNodes) {
      let values = treeNodes
      for (let node of values) {
        if (node.children && node.children.length > 0) {
          this.parentNodeIds.push(node.id)
          this.takeParentNodeIds(node.children)
        }
      }
    },
    submit() {
      this.checkedKeys.unshift.apply(this.checkedKeys, this.halfCheckedKeys)
      let menuIds = this.checkedKeys.join(',')
      let projectTypes = this.checkedTypes.join(',')
      console.log(this.roleId, menuIds)
      // this.saving = true
      saveRoleMenu(this.roleId, menuIds, projectTypes).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.visible = false
          this.$message.success('操作成功')
          this.clear()
        }
      })
    },
    onCheckChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.projectTypes.length
      this.checkAll = checkedList.length === this.projectTypes.length
    },
    onCheckAllSubjectChange(e) {
      Object.assign(this, {
        checkedTypes: e.target.checked ? this.projectTypes : [],
        indeterminate: false,
        checkAll: e.target.checked,
      })
    },
    clear() {
      this.checkedKeys = []
      this.halfChecked = []
      this.visible = false
    },
  },
  created() {
    this.getMenuTreeselect()
  },
}
</script>
